// types
import { IEfficiency } from './types'

// components
import { EfficiencyChart } from '../../components/EfficiencyChart'
import { ObjectAlarms } from '../../../features/Alarm/ObjectAlarms';


export function OperatorPanel(props: IEfficiency) {

    return (
        <>

            <EfficiencyChart resourceGroupId={props.resourceGroupId} id={props.id} value={props.efficiency} stepped={false} showAverage></EfficiencyChart>
            <ObjectAlarms resourceGroupId={props.resourceGroupId} id={props.id} />

        </>
    );
}
